module.exports = __webpack_public_path__ + "static/media/HealthHygieneServicesInner.ce1b5abb.png";